"use client"

import { useEffect, useState } from "react"
import { crudData } from "../../services/apiService"

function Services({ param }) {
  const [activeTab, setActiveTab] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"))
  const mode = JSON.parse(localStorage.getItem("appMode"))
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [data, setData] = useState({
    tabsData: [],
    listsData: {},
  })

  const handleTabClick = (tabId) => {
    setActiveTab(tabId)
  }

  const fetchData = (params, url) => {
    setIsLoading(true)
    crudData(params, url)
      .then((response) => {
        try {
          const responseData = typeof response.data === "string" ? JSON.parse(response.data) : response.data

          if (responseData?.data) {
            const apiData = responseData.data

            if (apiData.tabsData?.length > 0) {
              setData({
                tabsData: apiData.tabsData,
                listsData: apiData.listsData || {},
              })
              setActiveTab(apiData.tabsData[0]?.id || "")
            } else {
              console.log("Aucun onglet de livraison disponible")
              setData({ tabsData: [], listsData: {} })
            }
          } else {
            console.error("Structure de réponse inattendue:", responseData)
            setData({ tabsData: [], listsData: {} })
          }
        } catch (error) {
          console.error("Erreur de parsing JSON:", error)
          setData({ tabsData: [], listsData: {} })
        }
      })
      .catch((error) => {
        console.error("Erreur API:", error)
        setData({ tabsData: [], listsData: {} })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    const params = {
      mode: mode.getCalendarMode,
    }
    fetchData(params, apiEndpointe.CommandeManagerEndPoint)
  }, [userData?.LG_AGEID, mode.getCalendarMode, apiEndpointe.CommandeManagerEndPoint])

  // Fonction pour formater les dates
  const formatDate = (dateString) => {
    if (!dateString) return "Date non disponible"

    try {
      const date = new Date(dateString)
      return date.toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    } catch (error) {
      console.error("Erreur de formatage de date:", error)
      return dateString
    }
  }

  // Styles intégrés
  const styles = {
    container: {
      fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      color: "#2d3748",
      width: "100%",
    },
    mainContainer: {
      backgroundColor: "#d6e6ff", // Fond bleu clair simple comme dans l'image
      width: "100%",
      padding: "20px",
    },
    header: {
      padding: "20px 0",
      position: "relative",
    },
    title: {
      fontSize: "28px",
      fontWeight: "700",
      marginBottom: "12px",
      display: "flex",
      alignItems: "center",
      color: "#1a365d",
    },
    calendarIcon: {
      marginRight: "12px",
      display: "inline-flex",
    },
    description: {
      fontSize: "15px",
      lineHeight: "1.6",
      color: "#2c5282",
    },
    highlight: {
      fontWeight: "600",
    },
    important: {
      color: "#e53e3e",
      fontWeight: "600",
    },
    tabsContainer: {
      display: "flex",
      overflowX: "auto",
      scrollbarWidth: "thin",
      borderBottom: "1px solid #90cdf4",
      marginBottom: "20px",
    },
    tab: {
      padding: "12px 24px",
      fontSize: "15px",
      fontWeight: "500",
      color: "#4a5568",
      cursor: "pointer",
      border: "1px solid #90cdf4",
      borderBottom: "none",
      marginRight: "5px",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      backgroundColor: "#ebf8ff",
    },
    activeTab: {
      backgroundColor: "#3182ce",
      color: "white",
      fontWeight: "bold",
    },
    contentContainer: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "4px",
    },
    loadingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "40px 0",
    },
    spinner: {
      width: "40px",
      height: "40px",
      border: "4px solid rgba(66, 153, 225, 0.2)",
      borderRadius: "50%",
      borderTop: "4px solid #3182ce",
      animation: "spin 1s linear infinite",
    },
    regionTitle: {
      fontSize: "22px",
      fontWeight: "600",
      color: "#2c5282",
      marginBottom: "20px",
    },
    deliveryGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "20px",
    },
    deliveryCard: {
      border: "1px solid #e2e8f0",
      borderRadius: "4px",
      overflow: "hidden",
      backgroundColor: "#f7fafc",
    },
    deliveryHeader: {
      backgroundColor: "#2b6cb0",
      color: "white",
      padding: "10px 15px",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      alignItems: "center",
    },
    deliveryIcon: {
      marginRight: "8px",
    },
    deliveryContent: {
      padding: "15px",
    },
    deliveryInfo: {
      display: "flex",
      marginBottom: "12px",
      alignItems: "flex-start",
    },
    deliveryInfoLast: {
      marginBottom: "0",
    },
    infoIcon: {
      color: "#3182ce",
      marginRight: "12px",
      marginTop: "2px",
      flexShrink: "0",
    },
    infoContent: {
      flex: "1",
    },
    infoLabel: {
      fontSize: "13px",
      color: "#718096",
      marginBottom: "2px",
      fontWeight: "bold",
    },
    infoValue: {
      fontSize: "15px",
      color: "#2d3748",
    },
    deadlineIcon: {
      color: "#e53e3e",
    },
    deliveryDateIcon: {
      color: "#38a169",
    },
    areasIcon: {
      color: "#3182ce",
    },
    noData: {
      textAlign: "center",
      padding: "40px 0",
      color: "#718096",
      fontSize: "16px",
    },
  }

  return (
    <div className={`${param.userData ? "bgUserConnected" : ""}`} style={styles.container}>
      <div style={styles.mainContainer}>
        {/* En-tête */}
        <div style={styles.header}>
          <h2 style={styles.title}>
            <span style={styles.calendarIcon}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
            Calendrier de livraison général
          </h2>
          <p style={styles.description}>
            Les livraisons seront gratuites, mais nous ne prendrons pas les produits de nos concurrents.
            <span style={styles.highlight}> NB: Veuillez respecter la date limite de Commande </span>
            <span style={styles.important}>DONT L'HEURE LIMITE EST DE 12 H 00</span>, passer cette heure les commandes
            ne seront pas prises en compte pour la livraison de l'intérieur, pour nous permettre de préparer les colis,
            et ne pas retarder la livraison.
          </p>
        </div>

        {/* Onglets */}
        <div style={styles.tabsContainer}>
          {data.tabsData.map((tab) => (
            <div
              key={tab.id}
              style={{
                ...styles.tab,
                ...(activeTab === tab.id ? styles.activeTab : {}),
              }}
              onClick={() => handleTabClick(tab.id)}
            >
              {tab.title}
            </div>
          ))}
        </div>

        {/* Contenu */}
        <div style={styles.contentContainer}>
          {isLoading ? (
            <div style={styles.loadingContainer}>
              <div
                style={{
                  ...styles.spinner,
                  animation: "spin 1s linear infinite",
                }}
              ></div>
            </div>
          ) : data.tabsData?.length > 0 ? (
            <div>
              {data.tabsData.map((tab) => (
                <div key={tab.id} style={{ display: activeTab === tab.id ? "block" : "none" }}>
                  <h3 style={styles.regionTitle}>{tab.title}</h3>

                  {data.listsData[tab.id]?.length > 0 ? (
                    <div style={styles.deliveryGrid}>
                      {data.listsData[tab.id].map((item, index) => (
                        <div key={`${tab.id}-${index}`} style={styles.deliveryCard}>
                          <div style={styles.deliveryHeader}>
                            <span style={styles.deliveryIcon}>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <rect x="1" y="3" width="15" height="13"></rect>
                                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                                <circle cx="18.5" cy="18.5" r="2.5"></circle>
                              </svg>
                            </span>
                            LIVRAISON {item.id}
                          </div>
                          <div style={styles.deliveryContent}>
                            <div style={styles.deliveryInfo}>
                              <span style={{ ...styles.infoIcon, ...styles.deadlineIcon }}>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                              </span>
                              <div style={styles.infoContent}>
                                <div style={styles.infoLabel}>Date limite:</div>
                                <div style={styles.infoValue}>{formatDate(item.date)}</div>
                              </div>
                            </div>

                            <div style={styles.deliveryInfo}>
                              <span style={{ ...styles.infoIcon, ...styles.deliveryDateIcon }}>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                  <line x1="16" y1="2" x2="16" y2="6"></line>
                                  <line x1="8" y1="2" x2="8" y2="6"></line>
                                  <line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                              </span>
                              <div style={styles.infoContent}>
                                <div style={styles.infoLabel}>Livraison prévue:</div>
                                <div style={styles.infoValue}>{formatDate(item.deliveryDate)}</div>
                              </div>
                            </div>

                            <div style={{ ...styles.deliveryInfo, ...styles.deliveryInfoLast }}>
                              <span style={{ ...styles.infoIcon, ...styles.areasIcon }}>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                  <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                              </span>
                              <div style={styles.infoContent}>
                                <div style={styles.infoLabel}>Zones:</div>
                                <div style={styles.infoValue}>{item.areas}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={styles.noData}>
                      <p>Aucune livraison prévue pour cette région</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.noData}>
              <p>Pas de livraison prévue</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Services
